module.exports = __webpack_public_path__ + "static/media/nguyen-minh-hoang.80f64553.png";